import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { segmentsQueryKeys } from "@/features/segments/api/queryKeys";
import { instance } from "@/lib/axios/instance";
import { GetSegmentsResponse } from "@/types/response/GetSegmentsResponse";

interface UseSegmentsParams {
  clientId?: string;
  search?: string;
  enabled?: boolean;
}
const PAGE_SIZE = 100;
export function useSegments({
  clientId,
  search,
  enabled = true,
}: UseSegmentsParams) {
  return useQuery<GetSegmentsResponse, AxiosError>({
    queryKey: segmentsQueryKeys.list({
      clientId,
      page: 1,
      pageSize: PAGE_SIZE,
      search,
    }),
    enabled: enabled,
    queryFn: () =>
      instance
        .get("/api/v2/Segments", {
          params: {
            clientId,
            page: 1,
            pageSize: PAGE_SIZE, // Fetch more items at once for the dropdown
            search,
          },
        })
        .then((res) => res.data),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: true, // Overrides the global false so a newly saved segment is pickable without a reload
    placeholderData: keepPreviousData,
  });
}
